// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared settings-modal form: mono uppercase labels (the app field-label
   language), responsive auto-fit grid so fields wrap to new rows like cards
   instead of overlapping as the modal widens. Used by the bank-account and
   org-profile modals. */
.cfg-form {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 220px), 1fr));
  gap: 16px 20px;
}

.cfg-form__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.cfg-form__field--full {
  grid-column: 1 / -1;
}

.cfg-form__label {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.cfg-form__check {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.cfg-form__check span {
  font-size: var(--fs-2xs);
  color: var(--text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/shared/OrgModales/ModalForm.css"],"names":[],"mappings":"AAAA;;;wBAGwB;AACxB;EACE,aAAa;EACb,sEAAsE;EACtE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B","sourcesContent":["/* Shared settings-modal form: mono uppercase labels (the app field-label\n   language), responsive auto-fit grid so fields wrap to new rows like cards\n   instead of overlapping as the modal widens. Used by the bank-account and\n   org-profile modals. */\n.cfg-form {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 220px), 1fr));\n  gap: 16px 20px;\n}\n\n.cfg-form__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.cfg-form__field--full {\n  grid-column: 1 / -1;\n}\n\n.cfg-form__label {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.cfg-form__check {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.cfg-form__check span {\n  font-size: var(--fs-2xs);\n  color: var(--text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
